module.exports = __webpack_public_path__ + "img/shipmate--icon.0e12a403.svg";